import { Injectable } from '@angular/core'
import { HttpHeaders } from '@angular/common/http'

@Injectable()
export class global {

    // Local
   //public static readonly baseAPIUrl: string = "http://localhost:1037/api/";
    //public static readonly baseAPIUrl: string = "http://localhost:1066/api/";

    //Test 
    // public static readonly baseAPIUrl: string = "http://192.168.2.9:8083/";

    // Live 2.3
    //public static readonly baseAPIUrl: string = "https://college3.neteims.com:8118/frccollege/api/";
	
	// Live 19
   // public static readonly baseAPIUrl: string = location.protocol + "//aci.vnsgu.info/frccollege/api/";
    public static readonly baseAPIUrl: string = "https://aci.vnsgu.info/frccollege/api/";
     
    public static readonly pageLimit: number = 15;

    public static readonly httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };
}